export class DialogGeneralProps {
    constructor(
        public aberto: boolean = false,
    ) { }
}